import React, { useState, useEffect } from "react";
import { Page, Image, Text, Document, View, Table, Cell, TableHeader, TableRow, TableBody } from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import { styles } from "./StylesPDFInvoices";
import { currencyFormat } from '../../js/Functions';
import logoTC from "../../images/Dents.png"

const PDFInvoices = ({ data }) => {
	let [currentDate, setCurrentDate] = useState('');
	const [color, setColor] = useState('');
	let [observation, setObservation] = useState('');

	const setInfo = () => {
		if (data) {
			const currentDate = new Date().toJSON().slice(0, 10)
			console.log(currentDate)
			setCurrentDate(currentDate)
			console.log(data);
		}
	}
	useEffect(() => {
		setInfo()
	})
	return (
		data.invoice ?
			<Document>
				<Page style={styles.body} size="A4" wrap>
					<View style={styles.view}>
						<View style={styles.row}>
							<View style={[{ width: "180px" }, styles.col_header]}>
								<Image style={[{ width: 180, height: 90 }]} src={logoTC} />
							</View>
							<View style={[{ width: "175px" }, styles.col_header]}>
								
							</View>
							<View style={[{ width: "150px" }, styles.col_header]}>
								<View style={[styles.table, { border: 0 }]}>
									<Text style={{ textAlign: 'right', fontSize: '22px', color: '#8B91A7', fontWeight: 'bold' }}>INVOICE</Text>
								</View>
								<View style={[styles.table, { border: 0 }]}>
									<View style={[styles.tableRow]}>
										<View style={{ width: 85, padding: 0 }}>
											<Text style={{ textAlign: 'right' }}>DATE</Text>
										</View>
										<View style={[styles.tableCell, { width: 65, padding: 0 }]}>
											<Text style={{ textAlign: 'center' }}>{currentDate}</Text>
										</View>
									</View>
									<View style={[styles.tableRow]}>
										<View style={{ width: 85, padding: 0 }}>
											<Text style={{ textAlign: 'right' }}>INVOICE #</Text>
										</View>
										<View style={[styles.tableCell, { width: 65, padding: 0 }]}>
											<Text style={{ textAlign: 'center' }}>{data.invoice.INVOICE}</Text>
										</View>
									</View>
									<View style={[styles.tableRow]}>
										<View style={{ width: 85, padding: 0 }}>
											<Text style={{ textAlign: 'right' }}>QUOTATION #</Text>
										</View>
										<View style={[styles.tableCell, { width: 65, padding: 0 }]}>
											<Text style={{ textAlign: 'center' }}>{data.invoice.ID_QUOTATION}</Text>
										</View>
									</View>
									<View style={[styles.tableRow]}>
										<View style={{ width: 85, padding: 0 }}>
											<Text style={{ textAlign: 'right' }}>CUSTOMER #</Text>
										</View>
										<View style={[styles.tableCell, { width: 65, padding: 0 }]}>
											<Text style={{ textAlign: 'center' }}>{data.invoice.ID_CUSTOMER}</Text>
										</View>
									</View>
									<View style={[styles.tableRow]}>
										<View style={{ width: 85, padding: 0 }}>
											<Text style={{ textAlign: 'right' }}>DUE DATE</Text>
										</View>
										<View style={[styles.tableCell, { width: 65, padding: 0 }]}>
											<Text style={{ textAlign: 'center', backgroundColor: '#D7DBE6' }}>{data.invoice.INVOICE_DATE}</Text>
										</View>
									</View>
								</View>
							</View>
						</View>
						<View style={styles.row}>
							<View style={[{ width: 230, paddingTop: '3px', paddingLeft: '5px', marginRight: '1px' }]}>
								<Text style={{ marginBottom: 5 }}>PO BOX 1627 CLEVELAND, TX 77328</Text>
								<Text style={{ marginBottom: 5 }}>OFFICE: 281-432-7725</Text>
								<Text style={{ marginBottom: 5 }}>CELL: 281-806-6990</Text>
								<Text style={{ marginBottom: 5 }}>EMAIL: TCtransport20@gmail.com</Text>
							</View>
						</View>
						<View style={styles.row}>
							<View style={[{ width: 230, paddingTop: '3px', paddingLeft: '5px', marginRight: '1px', textAlign: "center" }]}>
								<Text style={{ marginBottom: 5, backgroundColor: "#003153", color: "#FFFFFF", fontWeight: "bold", fontSize: 12 }}>BILL TO</Text>
								<Text style={{ marginBottom: 5 }}>{data.customer.NAME}</Text>
								<Text style={{ marginBottom: 5 }}>{data.customer.ADDRESS}</Text>
								<Text style={{ marginBottom: 5 }}>{data.customer.PHONE}</Text>
							</View>
						</View>
						<View style={[styles.table, { marginTop: 5 }]}>
							<View style={[styles.tableRow, { backgroundColor: "#003153" }]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, borderBottom: 1, padding: 0 }]}>
									<Text style={{ textAlign: 'center', color: "#FFFFFF", fontWeight: "bold", fontSize: 12 }}>DESCRIPTION</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", borderTop: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', color: "#FFFFFF", fontWeight: "bold", fontSize: 12 }}>HUD #</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, borderBottom: 1, padding: 0 },]}>
									<Text style={{ textAlign: 'center', color: "#FFFFFF", fontWeight: "bold", fontSize: 12 }}>AMOUNT</Text>
								</View>
							</View>
							{
								data.items &&
								(
									<>
										{
											data.items.map((items, key) => (
												<View key={key} style={[styles.row, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
													<View style={[ styles.center_vertical_horizontal, { width: "60%", borderRight: '1px solid black' }]} >
														<Text style={{ fontWeight: "bold" }}>{items.DESCRIPTION}</Text>
													</View>
													<View style={[ styles.center_vertical_horizontal, { width: "20%", borderRight: '1px solid black' }]}>
														<Text style={{ width: 100, textAlign: "center" }}>{items.HUD_NUMBER}</Text>
													</View>
													<View style={[ styles.center_vertical_horizontal, { width: "20%", borderRight: '1px solid black' }]}>
														<Text style={{ textAlign: "right" }}>{currencyFormat(items.AMOUNT)}</Text>
													</View>
												</View>
											))
										}
										{
											Array.from({ length: 20 - data.items.length }).map((_, i) => (
												<View key={`empty-${i}`} style={[styles.row, { border: '1px solid black', borderTop: 0, justifyContent: 'center', paddingTop: 0 }]}>
													<View style={[styles.center_vertical_horizontal, { width: "60%", borderRight: '1px solid black' }]}>
														<Text> </Text>
													</View>
													<View style={[styles.center_vertical_horizontal, { width: "20%", borderRight: '1px solid black' }]}>
														<Text> </Text>
													</View>
													<View style={[styles.center_vertical_horizontal, { width: "20%", borderRight: '1px solid black' }]}>
														<Text> </Text>
													</View>
												</View>
											))
										}
									</>
									
								)
							}
						</View>
						<View style={[styles.table, { marginTop: 5, border: 0 }]}>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>SUBTOTAL</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.quotation.SUB_TOTAL}</Text>
								</View>
							</View>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>TAXES</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.quotation.TAXES}</Text>
								</View>
							</View>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>DISCOUNTS</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.quotation.DISCOUNTS}</Text>
								</View>
							</View>
							<View style={[styles.tableRow, { color: "#FFFFFF" }]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center',fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>TOTAL</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.quotation.TOTAL}</Text>
								</View>
							</View>
						</View>
						<View style={[{ width: "225px" }, styles.col_header]}>
							
						</View>
						<View style={[styles.table, { marginTop: 5, border: 0 }]}>
							<View style={[styles.tableRow, { color: "#FFFFFF" }]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center',fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>PAID</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.invoice.INVOICE_TOTAL}</Text>
								</View>
							</View>
							<View style={[styles.tableRow, { color: "#FFFFFF" }]}>
								<View style={[styles.tableCell, { width: "60%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center',fontWeight: "bold", fontSize: 12 }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>REMAINING</Text>
								</View>
								<View style={[styles.tableCell, { width: "20%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'right', fontWeight: "bold", fontSize: 12 }}>{data.invoice.INVOICE_REMAINING}</Text>
								</View>
							</View>
						</View>
						<View style={[styles.table, { marginTop: 5, border: 0 }]}>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "55%", border: 0, padding: 0, backgroundColor: "#003153" }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12, color: "#FFFFFF" }}>OTHER COMMENTS</Text>
								</View>
								<View style={[styles.tableCell, { width: "5%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "40%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}>Make all checks payable to: TC Transport</Text>
								</View>
							</View>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "55%", border: 0, padding: 0 }]}>
									<Text style={{ fontWeight: "bold" }}>{data.quotation.DETAILS}</Text>
								</View>
								<View style={[styles.tableCell, { width: "5%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "40%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}></Text>
								</View>
							</View>
						</View>
						{/* <View style={[styles.table, { marginTop: 50, border: 0 }]}>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "100%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 12 }}>Please confirm this Quotation</Text>
								</View>
							</View>
							<View style={[styles.tableRow, { marginTop: 50 }]}>
								<View style={[styles.tableCell, { width: "45%", border: 0, padding: 0 }]}>
									<Text style={{ fontWeight: "bold" }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "10%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "45%", border: 0, padding: 0 }]}>
									<Text style={{ fontWeight: "bold" }}></Text>
								</View>
							</View>
							<View style={[styles.tableRow, {}]}>
								<View style={[styles.tableCell, { width: "45%", border: 0, padding: 0, borderTop: '1px solid black' }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}>Signature on Printed Name</Text>
								</View>
								<View style={[styles.tableCell, { width: "10%", border: 0, padding: 0 }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}></Text>
								</View>
								<View style={[styles.tableCell, { width: "45%", border: 0, padding: 0, borderTop: '1px solid black' }]}>
									<Text style={{ textAlign: 'center', fontWeight: "bold" }}>Signature Date</Text>
								</View>
							</View>
						</View> */}
						{/* <View style={[styles.row, { marginTop: 100 }]}>
							<View style={[{ width: "100%" }, styles.col_header]}>
								<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 13 }}>If you have any questions about this invoice, please contact</Text>
							</View>
							<View style={[{ width: "100%" }, styles.col_header]}>
								<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 13 }}>TC Transport, 281-432-7725, TCtransport20@gmail.com</Text>
							</View>
							<View style={[{ width: "100%" }, styles.col_header]}>
								<Text style={{ textAlign: 'center', fontWeight: "bold", fontSize: 13 }}>Thank You For Your Business!</Text>
							</View>
						</View> */}
					</View>
					<Text style={[styles.pageNumber, { textAlign: 'center', fontWeight: "bold", fontSize: 13 }]} fixed>Thank You For Your Business!</Text>
				</Page>
			</Document>
		: ''
		// data.itemResultAporte ?
		// 	(
		// 		<Document>
		// 			<Page style={styles.body} size="A4" wrap>
		// 				<View style={styles.view}>
		// 					{/* header */}
							// <View style={styles.row}>
							// 	<View style={[{ width: "130px", }, styles.col_header]}>
							// 		<Image style={[{ width: 90, height: 90, }]} src={logoAGM} />
							// 	</View>
							// 	<View style={[{ width: "225px" }, styles.col_header]}>
							// 		<Text>AGM DESARROLLOS S.A.S.</Text>
							// 		<Text>NIT: 800186313-0</Text>
							// 		<Text>CENTRO, SECTOR MATUNA, AV. DANIEL</Text>
							// 		<Text>LEMAITRE, EDF. BANCO DEL ESTADO PISO 5</Text>
							// 		<Text>CARTAGENA - COLOMBIA</Text>
							// 	</View>
							// 	<View style={[{ borderRadius: '10px', border: "1px solid black", width: "150px", }, styles.col_header]}>
							// 		<Text >CUENTA DE COBRO</Text>
							// 		<Text style={[{ color: 'red', }]}>{data.itemResultAporte.CONSECUTIVO_FACT}</Text>
							// 	</View>
							// </View>
		// 					{/* body  client info*/}
		// 					<View style={styles.row}>
		// 						<View style={[{ width: 354, borderRadius: '10px', border: "1px solid black", paddingTop: '3px', paddingLeft: '5px', marginRight: '1px' },]}>
		// 							<Text style={{ marginBottom: 5 }}>Cliente:           MUNICIPIO DE {data.itemResultAporte.MUNICIPIO}</Text>
		// 							<Text style={{ marginBottom: 5 }}>NIT:                {data.itemResultAporte.NIT_ALCALDIA}</Text>
		// 							<Text style={{ marginBottom: 5 }}>Dirección:       {data.itemResultAporte.DIRECCION_ALCALDIA}</Text>
		// 							<Text style={{ marginBottom: 5 }}>Ciudad:           {data.itemResultAporte.MUNICIPIO}</Text>
		// 							<Text style={{ marginBottom: 5 }}>Teléfono:         {data.itemResultAporte.TELEFONO_ALCALDIA}</Text>
		// 						</View>
		// 						<View style={[{ width: 150, borderRadius: '10px', border: "1px solid black", paddingTop: '3px', paddingLeft: '5px', justifyContent: 'center' },]}>
		// 							<Text style={{ marginBottom: 5 }}>Fecha:                    {data.itemResultAporte.FECHA_FACTURA}</Text>
		// 							<Text style={{ marginBottom: 5 }}>Forma de Pago:      MENSUAL</Text>
		// 							<Text style={{ marginBottom: 5 }}>Fecha de Vcto:        {data.itemResultAporte.FECHA_VENCIMIENTO}</Text>
		// 						</View>
		// 					</View>
							// <View style={styles.table}>
							// 	<View style={[styles.tableRow,]}>
							// 		<View style={[styles.tableCell, { width: 40, border: 0, borderBottom: 1, }]}>
							// 			<Text style={{ textAlign: 'center' }}>Ítem:</Text>
							// 		</View>
							// 		<View style={[styles.tableCell, { width: 370, borderBottom: 1, borderTop: 0 }]}>
							// 			<Text style={{ textAlign: 'center' }}>Descripción</Text>
							// 		</View>
							// 		<View style={[styles.tableCell, { width: 95, border: 0, borderBottom: 1 },]}>
							// 			<Text style={{ textAlign: 'center' }}>Valor Bruto</Text>
							// 		</View>
							// 	</View>
		// 						<View style={styles.tableRow}>
		// 							<View style={[styles.tableCell, { width: 40, border: 0, }]}>
		// 								<Text style={{ textAlign: 'center', marginTop: 20 }}>1</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 370, borderBottom: 0, borderTop: 0 }]}>
		// 								<View>
		// 									<Text style={{}}>
		// 										{`${data.itemResultAporte.CONCEPTO_APORTE} CORRESPONDIENTE AL MES DE ${data.mesFactura} DEL AÑO ${data.anoFactura}`}
		// 									</Text>
		// 								</View>
		// 								<View style={[{ marginTop: 12, marginBottom: 5 }]}>
		// 									<Text style={{}}>
		// 										APORTE AL MUNICIPIO
		// 									</Text>
		// 								</View>
		// 								<Text style={{}}>
		// 									Total Valor Aporte
		// 								</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 95, border: 0 }]}>
		// 								<Text style={{}}>{" "}</Text>
		// 								<Text style={{}}>{" "}</Text>
		// 								<Text style={{ textAlign: 'right', marginTop: 12, marginBottom: 5 }}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text>
		// 								<Text style={{ textAlign: 'right' }}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text>
		// 							</View>
		// 						</View>
		// 						<View style={[styles.tableRow,]}>
		// 							<View style={[styles.tableCell, { width: '100%', border: 0, borderTop: 1, }]}>
		// 								<Text style={[{ marginBottom: 10 }]}>VALOR EN LETRAS</Text>
		// 								{
		// 									data.valorEnLetras ? (<Text style={[{ marginBottom: 10 }]}>{data.valorEnLetras}</Text>) : ''
		// 								}
		// 							</View>
		// 						</View>
		// 						<View style={[styles.tableRow,]}>
		// 							<View style={[styles.tableCell, { width: '100%', border: 0, borderTop: 1, }]}>
		// 								<Text style={[{ marginBottom: 10 }]}>CUENTAS COBRO VENCIDAS: <Text style={[{ color: `${color}` }]}>{currencyFormat(data.itemResultAporte.NO_CC_VENCIDAS)}</Text></Text>
		// 								{
		// 									data.itemResultAporte.FECHA_VENCIMIENTO > currentDate ?
		// 										(
		// 											<View>
		// 												<Text style={[{ marginBottom: 10 }]}>CARTERA CORRIENTE: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text></Text>
		// 												<Text style={[{ marginBottom: 10 }]}>CARTERA VENCIDA: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_CARTERA - data.itemResultAporte.VALOR_FACTURA)}</Text></Text>
		// 											</View>
		// 										) :
		// 										(
		// 											<View>
		// 												<Text style={[{ marginBottom: 10 }]}>CARTERA CORRIENTE: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(0)}</Text></Text>
		// 												<Text style={[{ marginBottom: 10 }]}>CARTERA VENCIDA: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_CARTERA)}</Text></Text>
		// 											</View>
		// 										)
		// 								}
		// 							</View>
		// 						</View>
		// 					</View>
		// 					<View style={[styles.table, { borderRadius: '10px', marginTop: 3 }]}>
		// 						<View style={[styles.tableRow, { marginTop: 1 }]}>
		// 							<View style={[styles.tableCell, { width: '100%', border: 0, }]}>
		// 								<Text style={[{ marginBottom: 10 }]}>Observaciones</Text>
		// 								<Text style={[{ marginBottom: 10 }]}>{observation}</Text>
		// 							</View>
		// 						</View>
		// 					</View>
		// 					<View style={[styles.table, { marginTop: 10 }]}>
		// 						<View style={[styles.tableRow, { marginTop: 1 }]}>
		// 							<View style={[styles.tableCell, { width: '100%', border: 0, }]}>
		// 								<Text style={[{ marginBottom: 10 }]}>El concepto cobrado en este documento corresponde a la obligación pactada, con ocasión al Contrato de Concesión celebrado
		// 									entre la entidad territorial y la empresa que emite la presente cuenta de cobro, correspondiente al aporte mensual que debe
		// 									realizar el Municipio para la financiación de la prestación del servicio de Alumbrado Público.
		// 								</Text>
		// 							</View>
		// 						</View>
		// 					</View>
		// 					<View style={[styles.table, { border: 0, marginTop: 80 }]}>
		// 						<View style={[styles.tableRow,]}>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, borderBottom: 1, marginRight: 15 }]}>
		// 								<Text style={{ textAlign: 'center' }}>{data.itemResultAporte.USUARIO}</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 170, border: 0, borderBottom: 1, }]}>
		// 								<Text style={{ textAlign: 'center', }}>PAOLA PALMIERI M</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, borderBottom: 1, marginLeft: 15 },]}>
		// 								<Text style={{ textAlign: 'center' }}>ARNOLD ÁLVAREZ</Text>
		// 							</View>
		// 						</View>
		// 						<View style={[styles.tableRow,]}>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, marginRight: 15 }]}>
		// 								<Text style={{ textAlign: 'center' }}>Elaborado</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 170, border: 0, }]}>
		// 								<Text style={{ textAlign: 'center' }}>Revisado</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, marginLeft: 15 }]}>
		// 								<Text style={{ textAlign: 'center' }}>Aprobación de Gerencia</Text>
		// 							</View>
		// 						</View>
		// 						<View style={[styles.tableRow, { marginTop: 20 }]}>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, marginRight: 15 }]}>
		// 								<Text style={{ textAlign: 'center' }}></Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 170, border: 0, }]}>
		// 								<Text style={{ textAlign: 'center' }}>ORIGINAL</Text>
		// 							</View>
		// 							<View style={[styles.tableCell, { width: 150, border: 0, marginLeft: 15 }]}>
		// 								<Text style={{ textAlign: 'center' }}></Text>
		// 							</View>
		// 						</View>
		// 					</View>
		// 				</View>
		// 				<Text
		// 					style={styles.pageNumber}
		// 					render={({ pageNumber, totalPages }) =>
		// 						`${pageNumber} / ${totalPages}`
		// 					}
		// 					fixed
		// 				/>
		// 			</Page>
		// 		</Document>
		// 	)
		// 	:
		// 	""
	);
};

export default PDFInvoices;
